module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Vto8YZ/images/Cover.jpg?1737821500381",
      "alt": "This image is the cover for the book Vashon Island Visitors, Creeps & Shrieks"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Vashon Island Visitors, Creeps & Shrieks\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("FINDING THEIR MISSING GRANDMA   WILL BE  NO SMALL FEAT!    Rubi and her much more daring--and skateboard-obsessed--brother, Quinn, are visiting their grandmother on beautiful Vashon Island for the weekend. It's the first time they've taken the ferry from Seattle by themselves. But weirdly, when they arrive, Nana is nowhere to be found!   Then their Uncle James lets them in on a little secret:  Bigfoot  may have been spotted! And their Nana isn't  any  old grandma--she's the most famous Bigfoot hunter around! Trouble is, Nana should've returned by now. And nobody in all of Puget Sound has seen her! At least... nobody  human.   Rubi and Quinn will have to follow the footprints (and scat!), crack the clues, and rely on each other to find their Nana and bring her home... that is, unless Bigfoot finds them  first !")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Stacia Deutsch\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("New York Times  bestselling author STACIA DEUTSCH has written more than three hundred children's books, including  The Jessie Files , a spin-off of the beloved  Boxcar Children  mystery series. Stacia lives in Temecula, California, where she is a member of the historical society. She loves hearing spooky stories! Find her at  www.staciadeutsch.com . Instagram @staciadeutsch_writes and www.facebook/staciadeutsch.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Arcadia Children’s Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0